import React from "react";

/** Minimal skeleton primitives that respect dark mode via CSS vars. */
export function Skeleton({ className = "", style = {} }) {
  return (
    <div
      className={`animate-pulse rounded-md bg-slate-200/80 dark:bg-slate-700/40 ${className}`}
      style={style}
      data-testid="skeleton"
    />
  );
}

export function SkeletonText({ lines = 3, widths = ["100%", "85%", "60%"] }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className="h-3" style={{ width: widths[i % widths.length] }} />
      ))}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="card-pb p-5">
      <Skeleton className="h-4 w-32 mb-3" />
      <Skeleton className="h-8 w-24 mb-4" />
      <SkeletonText lines={2} />
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div className="flex items-center gap-3 px-5 py-3 border-b border-[#E2E8F0] dark:border-slate-700">
      <Skeleton className="w-8 h-8 rounded-full" />
      <div className="flex-1 space-y-1.5">
        <Skeleton className="h-3 w-1/3" />
        <Skeleton className="h-2.5 w-1/2" />
      </div>
      <Skeleton className="h-4 w-16" />
    </div>
  );
}
